import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showVerifyHint, setShowVerifyHint] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // After Zerodha OAuth, server redirects to /dashboard?... — if session restore is slow, send user back with query intact
  useEffect(() => {
    if (!authLoading && user) {
      const q =  location.search || '';
      navigate(`/dashboard${q}`, { replace: true });
    }
  }, [authLoading, user, location.search, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setShowVerifyHint(false);
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
      setShowVerifyHint(result.code === 'EMAIL_NOT_VERIFIED');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/tradelensy-logo.png" alt="Tradelensy logo" className="auth-logo" />
          <h1>Tradelensy</h1>
        </div>
        <h2>Login</h2>
        {error && <div className="error-message">{error}</div>}
        {showVerifyHint && (
          <p className="auth-link" style={{ marginBottom: '16px' }}>
            <Link to="/check-email" state={{ email }}>
              Resend verification email
            </Link>
          </p>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <p className="auth-link">
          <Link to="/forgot-password">Forgot password?</Link>
        </p>
        <p className="auth-link">
          <Link to="/">← Back to home</Link>
        </p>
        <p className="auth-link">
          Don't have an account? <Link to="/register">Register here</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
